/* eslint-disable react/prop-types */
import * as React from 'react';

export const ClockDash = ({ color = '#64748B', size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.298 13.5278L14.489 15.4378C14.65 15.5338 14.827 15.5798 15.002 15.5798C15.341 15.5798 15.673 15.4068 15.86 15.0938C16.144 14.6198 15.99 14.0058 15.516 13.7218L12.812 12.1028V8.5498C12.812 7.9978 12.364 7.5498 11.812 7.5498C11.259 7.5498 10.812 7.9978 10.812 8.5498V12.6698C10.812 13.0218 10.996 13.3468 11.298 13.5278Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.56612 4.34029C8.73012 4.44229 8.91212 4.49029 9.09112 4.49029C9.42612 4.49029 9.75312 4.32229 9.94212 4.01629L9.94912 4.00629C10.2401 3.53629 10.0911 2.92529 9.62212 2.63429C9.15112 2.34429 8.53312 2.49429 8.24212 2.96429C7.95112 3.43329 8.09612 4.04929 8.56612 4.34029Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.18033 6.51998L6.18533 6.50998C6.42233 6.01098 6.20833 5.41998 5.70933 5.18198C5.21233 4.94398 4.61233 5.16198 4.37433 5.66098C4.13733 6.15898 4.34833 6.75598 4.84733 6.99298C4.98633 7.05898 5.13233 7.08998 5.27733 7.08998C5.65033 7.08998 6.00933 6.87998 6.18033 6.51998Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.22952 11.2404C3.57652 11.2404 3.91452 11.0594 4.09852 10.7364L4.10452 10.7264C4.37852 10.2464 4.20852 9.64145 3.72952 9.36645C3.24952 9.09345 2.63552 9.26445 2.36252 9.74445C2.08852 10.2234 2.25452 10.8344 2.73452 11.1084C2.89052 11.1984 3.06152 11.2404 3.22952 11.2404Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.99132 13.9478C3.51732 13.6638 2.90032 13.8228 2.61632 14.2958C2.33232 14.7688 2.48532 15.3838 2.95932 15.6678C3.12032 15.7638 3.29732 15.8098 3.47232 15.8098C3.81232 15.8098 4.14332 15.6368 4.33132 15.3248L4.33732 15.3148C4.62132 14.8418 4.46532 14.2318 3.99132 13.9478Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.41322 17.7005C5.92022 17.4535 5.31622 17.6585 5.06922 18.1525C4.82222 18.6465 5.02222 19.2475 5.51622 19.4945C5.66022 19.5665 5.81222 19.5995 5.96222 19.5995C6.33022 19.5995 6.68322 19.3975 6.85822 19.0475L6.86322 19.0375C7.11022 18.5435 6.90722 17.9475 6.41322 17.7005Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1003 2H12.0983C11.5473 2 11.0993 2.446 11.0983 2.998C11.0973 3.55 11.5443 3.999 12.0963 4C16.5073 4.009 20.0913 7.602 20.0853 12.009C20.0823 14.146 19.2473 16.155 17.7343 17.665C16.2253 19.171 14.2223 20 12.0903 20H12.0733C11.0803 20 10.1193 19.821 9.21637 19.468C8.70037 19.268 8.12137 19.522 7.92037 20.036C7.72037 20.551 7.97437 21.13 8.48837 21.332C9.63137 21.777 10.8023 21.98 12.0923 22C14.7553 22 17.2603 20.963 19.1473 19.081C21.0383 17.193 22.0813 14.683 22.0853 12.012C22.0933 6.502 17.6133 2.011 12.1003 2Z"
      fill={color}
    />
  </svg>
);
